export class FeatureAnnouncementModel {
  id: number;
  title: string;
  // HTML snippet
  body: string;
  imageUrl: string | null;
  routePath: string | null;
  routeLabel: string | null;
}
